import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatListModule } from '@angular/material/list';
import { MatTooltipModule } from '@angular/material/tooltip';

import { RdsVariableInformationComponent } from './variable-information';
import { RdsVariableInformationDecoratorsComponent } from './variable-information-decorators.component';

const COMPONENTS = [RdsVariableInformationDecoratorsComponent, RdsVariableInformationComponent];

@NgModule({
  imports: [CommonModule, MatIconModule, MatListModule, MatButtonModule, MatTooltipModule],
  declarations: [COMPONENTS],
  exports: [COMPONENTS]
})
export class RdsVariableInformationModule {}

export * from './variable-information';
export * from './variable-information-decorators.component';
